<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="schoolSummary && schoolProgress">
			<title-bar title="Progreso" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<div class="col full">
				<div class="row between innerRubric">
					<progress-chart v-for="category in progressionReport.coachingCategories" :key="category.id" :categoryId="category.id" :data="category.graphData" :title="category.name" :percentage="category.percentage"/>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else return this.$store.state.school.summary;
		},
		schoolProgress () {
			return this.$store.state.school.progress;
		},
		progressionReport () {
			if (!this.schoolProgress) return [];
			this.schoolProgress[0].coachingCategories.forEach((coachingCategory) => {
				coachingCategory.graphData = {
					labels: this.schoolProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == coachingCategory.id) result = parseInt(category.percentage);
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets:	[{
						data: this.schoolProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == coachingCategory.id) result = parseInt(category.percentage);
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.schoolProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
				return coachingCategory;
			});
			return this.schoolProgress[0];
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/school/CategoriesProgress.vue